export function NotFound() {
  return (
    <section>
      <h1>Not found</h1>
      <p>The page you requested does not exist.</p>
    </section>
  );
}
